import { CrisisStreamResponse } from 'types/Crisis/crisis-stream'
import { InferType, object, string } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object({
  streamId: string().required(),
})

export type Request = InferType<typeof Schema>

export type SuccessfulResponse = CrisisStreamResponse

export const url = ({ streamId }: Request) => `/v1/crisis-streams/${streamId}`
